// src/Informes/Components/Tables.js
import { renderCell, renderCellContent, renderNumericValue } from "./helpers";
import dayjs from "dayjs";

// Tabla de Contactos
export const columnsTableContacts = [
  {
    Header: `CONTACTOS POR ESTADO`,
    columns: [
      {
        Header: "Fecha",
        accessor: "fecha",
        Cell: ({ value }) => (value ? dayjs(value).format("DD/MM/YYYY") : "-"),
      },
      {
        Header: "Pendiente Llamada",
        accessor: "Pte",
        Cell: ({ value }) => renderNumericValue(value),
      },
      {
        Header: "Llamado",
        accessor: "Llamado",
        Cell: ({ value }) => renderNumericValue(value),
      },
      {
        Header: "Cliente",
        accessor: "Cliente",
        Cell: ({ value }) => renderNumericValue(value),
      },
      {
        Header: "Cancelado",
        accessor: "Cancelado",
        Cell: ({ value }) => renderNumericValue(value),
      },
      {
        Header: "Total Contactos",
        accessor: "Total",
        Cell: ({ value }) => renderNumericValue(value),
      },
    ],
  },
];

// Tabla de Clientes
export const columnsTableClients = [
  {
    Header: `CLIENTES POR MES Y ASOCIACIÓN`,
    columns: [
      {
        Header: "Año",
        accessor: "year",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Mes",
        accessor: "month",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Asociación",
        accessor: "asociations_relation",
        width: "400px",
        Cell: ({ value }) => renderCellContent(value),
      },
      {
        Header: "Clientes",
        accessor: "total",
        Cell: ({ value }) => renderNumericValue(value),
      },
    ],
  },
];

// Tabla de Expedientes
export const columnsTableAsocZone = [
  {
    Header: `Expedientes por Asociación y Zona`,
    columns: [
      {
        Header: "Asociación",
        accessor: "asociations_relation",
        Cell: ({ value }) => renderCellContent(value),
      },
      // {
      //   Header: "Zona",
      //   accessor: "zones_relation",
      //   Cell: ({ value }) => renderCellContent(value, "SIN ZONA"),
      // },
      {
        Header: "Provincia",
        accessor: "province",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Cantidad",
        accessor: "total_cases",
        Cell: ({ value }) => renderNumericValue(value),
      },
    ],
  },
];

// Tabla de Contratos firmados
export const columnsTableContracts = [
  {
    Header: `CONTRATOS ACEPTADOS POR FECHA`,
    columns: [
      {
        Header: "Fecha",
        accessor: "fecha",
        Cell: ({ value }) => (value ? dayjs(value).format("DD/MM/YYYY") : "-"),
      },
      {
        Header: "Contrato",
        accessor: "contract_title",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Firmas",
        accessor: "total",
        Cell: ({ value }) => renderNumericValue(value),
      },
    ],
  },
];
